<template>
  <div class="mt-2">
    <v-card class="mx-auto" max-width="95%" elevation="1">
      <v-tabs v-model="tab" background-color="indigo darken-2" dark slider-color="amber" show-arrows>
        <v-tab href="#today">
          <v-icon left small>mdi-flash</v-icon>오늘 실시간
        </v-tab>
        <v-tab href="#daily">
          <v-icon left small>mdi-calendar-range</v-icon>일별 통계
        </v-tab>
        <v-tab href="#monthly">
          <v-icon left small>mdi-calendar-month</v-icon>월별 통계
        </v-tab>
        <v-tab href="#media">
          <v-icon left small>mdi-store-search</v-icon>매체 상세
        </v-tab>
        <v-tab href="#cron">
          <v-icon left small>mdi-clock-check</v-icon>cron 상태
        </v-tab>
      </v-tabs>
    </v-card>

    <v-tabs-items v-model="tab" class="mt-0" style="background:transparent;">
      <v-tab-item value="today"   eager><stats-today   v-if="tab==='today'"  /></v-tab-item>
      <v-tab-item value="daily"   eager><stats-daily   v-if="tab==='daily'"  /></v-tab-item>
      <v-tab-item value="monthly" eager><stats-monthly v-if="tab==='monthly'"/></v-tab-item>
      <v-tab-item value="media"   eager><stats-media   v-if="tab==='media'"  /></v-tab-item>
      <v-tab-item value="cron"    eager><stats-cron    v-if="tab==='cron'"   /></v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import StatsToday   from './Stats_Today.vue';
import StatsDaily   from './Stats_Daily.vue';
import StatsMonthly from './Stats_Monthly.vue';
import StatsMedia   from './Stats_Media.vue';
import StatsCron    from './Stats_CronStatus.vue';

const VALID_TABS = ['today', 'daily', 'monthly', 'media', 'cron'];

export default {
  name: 'Danta_Stats_Index',
  components: {
    StatsToday, StatsDaily, StatsMonthly, StatsMedia, StatsCron,
  },
  data() {
    return { tab: this._initialTab() };
  },
  watch: {
    tab(v) {
      // URL hash 동기화 — 새로고침 / 뒤로가기 보존, 외부 링크 공유 가능.
      if (v && this.$route.hash !== `#${v}`) {
        this.$router.replace({ hash: `#${v}` });
      }
    },
    '$route.hash'(h) {
      const next = (h || '').replace('#', '');
      if (VALID_TABS.includes(next) && this.tab !== next) this.tab = next;
    },
  },
  methods: {
    _initialTab() {
      const h = (this.$route.hash || '').replace('#', '');
      return VALID_TABS.includes(h) ? h : 'today';
    },
  },
};
</script>
